import styled, { css } from 'styled-components';
import { skeleton } from 'src/components/skeleton';
import * as Layout from '../styles';

export const DesktopStage = Layout.DesktopStage;
export const ProgressRow = Layout.ProgressRow;
export const SessionLayout = Layout.Layout;
export const MediaColumn = Layout.MediaColumn;
export const ContentColumn = Layout.ContentColumn;
export const CardArea = Layout.CardArea;
export const MobileStage = Layout.MobileStage;
export const MobileOverlay = Layout.MobileOverlay;
export const MobileCardBody = Layout.MobileCardBody;
export const MobileContent = Layout.MobileContent;

export const Bone = styled.div(
  ({ theme }) => css`
    border-radius: ${theme.bo.small};
    ${skeleton};
  `,
);

export const HeaderBar = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.sz.s4};
    padding: ${theme.sz.s3} ${theme.sz.s8};
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.primary90};

    @media (max-width: 64rem) {
      padding-inline: ${theme.sz.s6};
    }
  `,
);

export const LogoBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s28};
    height: ${theme.sz.s6};
  `,
);

export const HeaderActions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
  `,
);

export const HeaderPill = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s16};
    height: ${theme.sz.s8};
    border-radius: ${theme.bo.round};
  `,
);

export const ProgressTrack = styled.div(
  ({ theme }) => css`
    display: flex;
    flex: 1;
    gap: ${theme.sz.s1};
    min-width: 0;
  `,
);

export const ProgressSegment = styled(Bone)(
  ({ theme }) => css`
    flex: 1;
    height: ${theme.sz.s1};
    border-radius: ${theme.bo.round};
  `,
);

export const ExitBone = styled(Bone)(
  ({ theme }) => css`
    flex-shrink: 0;
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    border-radius: ${theme.bo.round};
  `,
);

export const ProgressRowInner = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
    width: 100%;
  `,
);

export const MediaBone = styled(Bone)`
  position: absolute;
  inset: 0;
  border-radius: 0;
`;

export const CardContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.sz.s3};
    width: 100%;
  `,
);

export const PhraseBone = styled(Bone)(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s48});
    height: ${theme.sz.s12};
  `,
);

export const DefinitionBone = styled(Bone)(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s32});
    height: ${theme.sz.s4};
  `,
);

export const ButtonBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s28};
    height: ${theme.sz.s11};
    margin-top: ${theme.sz.s4};
    border-radius: ${theme.bo.round};
  `,
);

export const MobileTopBar = styled.div(
  ({ theme }) => css`
    position: absolute;
    inset-inline: 0;
    top: 0;
    z-index: ${theme.zi.z3};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    padding: calc(${theme.sz.s3} + env(safe-area-inset-top)) ${theme.sz.s4} ${theme.sz.s6};
  `,
);

export const MobileTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MobileBackBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    border-radius: ${theme.bo.round};
  `,
);

export const MobileStats = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
  `,
);

export const MobileStatBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s10};
    height: ${theme.sz.s5};
    border-radius: ${theme.bo.round};
  `,
);

export const MobileMediaBone = styled(Bone)`
  position: absolute;
  inset: 0;
  border-radius: 0;
`;

export const MobilePhraseBone = styled(Bone)(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s40});
    height: ${theme.sz.s8};
  `,
);

export const MobileDefinitionBone = styled(Bone)(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s28});
    height: ${theme.sz.s4};
  `,
);

export const MobileButtonBone = styled(Bone)(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.sz.s11};
    margin-top: ${theme.sz.s2};
    border-radius: ${theme.bo.round};
  `,
);
